<template>
	<div class="action-flow-node action-flow-node-trigger" style="height: 200px;">
		<div class="action-flow-title">Click Trigger</div>
		<div class="action-flow-hint">Flow starts from here when a button is clicked.</div>
		
		<ActionParamHint label="Button" hint="Which component on what page is being clicked?" param-class="param-config"
			param-input-type="select" param-input-label="Button Source" @param-change="handleParamChange"
			:param-input-options="[{ value: 'editor', label: 'Editor Button' }, { value: 'itemview', label: 'Item View Button' }]"
			:param-input-value="parameters.button"
		/>
		<ActionParamHint label="Mote" hint="Mote associated with the button, if applicable." param-class="param-src" />
		<ActionParamHint label="Component" hint="Parent component of the button." param-class="param-src" />
		
		<Handle type="source" id="src-mote" :position="Position.Right" style="top: 135px;" />
		<Handle type="source" id="src-component" :position="Position.Right" style="top: 175px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	button: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			button: newNodeData.data?.button || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>